export default "__VITE_ASSET__ce38fe77__"